import React from 'react';
import { motion } from 'framer-motion';

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸', ttsVoice: 'o7wLjIyo9bvhdUh12QMc' },
  { code: 'es', name: 'Español', flag: '🇪🇸', ttsVoice: 'Xb7hH8MSUJpSbSDYk0k2' },
  { code: 'hi', name: 'हिंदी', flag: '🇮🇳', ttsVoice: 'TX3LPaxmHKxFdv7VOQHJ' },
  { code: 'ta', name: 'தமிழ்', flag: '🇮🇳', ttsVoice: 'TX3LPaxmHKxFdv7VOQHJ' },
  { code: 'te', name: 'తెలుగు', flag: '🇮🇳', ttsVoice: 'TX3LPaxmHKxFdv7VOQHJ' },
  { code: 'zh', name: '中文', flag: '🇨🇳', ttsVoice: 'ThT5KcBeYPX3keUQqHPh' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', ttsVoice: 'FGY2WhTYpPnrIDTdsKH5' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', ttsVoice: 'sB0xoLxBqUwlT2KptNIi' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', ttsVoice: 'ThT5KcBeYPX3keUQqHPh' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', ttsVoice: 'ThT5KcBeYPX3keUQqHPh' },
  { code: 'pt', name: 'Português', flag: '🇧🇷', ttsVoice: 'ThT5KcBeYPX3keUQqHPh' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', ttsVoice: 'TX3LPaxmHKxFdv7VOQHJ' },
];

function LanguageTile({ language, isSelected, onClick, compact = false }) {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.98 }}
      style={{
        padding: compact ? '8px 12px' : '12px 16px',
        borderRadius: compact ? 12 : 16,
        border: isSelected 
          ? '2px solid rgba(255,255,255,0.6)' 
          : '1px solid rgba(255,255,255,0.2)',
        background: isSelected 
          ? 'rgba(255,255,255,0.2)' 
          : 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 6 : 10,
        transition: 'all 0.2s',
        minWidth: compact ? 'auto' : 120,
      }}
    >
      <span style={{ fontSize: compact ? 18 : 24 }}>{language.flag}</span>
      <span style={{ 
        fontSize: compact ? 13 : 15, 
        color: 'rgba(255,255,255,0.95)',
        fontWeight: isSelected ? 600 : 400,
      }}>
        {language.name}
      </span>
    </motion.button>
  );
}

export default function LanguageSelector({ 
  value, 
  onChange, 
  compact = false, 
  showLabel = true,
  gridCols = 3,
}) {
  const selected = value || 'en';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: compact ? 8 : 16,
      width: '100%',
    }}>
      {showLabel && (
        <label style={{
          fontSize: 14,
          color: 'rgba(255,255,255,0.7)',
          fontWeight: 500,
        }}>
          Preferred Language
        </label>
      )}
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
        gap: compact ? 8 : 12,
      }}>
        {LANGUAGES.map((lang) => (
          <LanguageTile
            key={lang.code}
            language={lang}
            isSelected={selected === lang.code}
            onClick={() => onChange(lang.code)}
            compact={compact}
          />
        ))}
      </div>
    </div>
  );
}

// Export languages for use in TTS mapping
export { LANGUAGES };
